// extracted by mini-css-extract-plugin
export default {"search-chip":"fH8FYGVIkZNP9_IW1tLQ"};